import React from 'react';
import { Users2, TrendingUp, AlertTriangle, Star } from 'lucide-react';

interface StakeholderMetricsProps {
  dealId?: string;
}

export default function StakeholderMetrics({ dealId }: StakeholderMetricsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Total Stakeholders</h3>
          <Users2 className="w-5 h-5 text-blue-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">24</p>
        <p className="mt-1 text-sm text-gray-500">Across all categories</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Key Influencers</h3>
          <Star className="w-5 h-5 text-yellow-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">8</p>
        <p className="mt-1 text-sm text-gray-500">High influence stakeholders</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">Support Level</h3>
          <TrendingUp className="w-5 h-5 text-green-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">75%</p>
        <p className="mt-1 text-sm text-gray-500">Positive sentiment</p>
      </div>

      <div className="bg-white p-4 rounded-lg shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-gray-700">At Risk</h3>
          <AlertTriangle className="w-5 h-5 text-red-500" />
        </div>
        <p className="text-2xl font-bold text-gray-900">3</p>
        <p className="mt-1 text-sm text-gray-500">Need attention</p>
      </div>
    </div>
  );
}